export interface PromoterFilterType {
  selectedPromoters: server.dto.CompanySmall[]
}

export const getPromoterLabels = (filter: PromoterFilterType) => {
  return filter.selectedPromoters.map(a => a.name)
    .sort((a, b) => a.localeCompare(b));
};

export const initialPromoterFilter: PromoterFilterType = {
  selectedPromoters: []
};